<template>
  <div class="container">
    <div class="list-warp" ref="refListWarp">
      <ul class="list" ref="refListTab">
        <li class="item" v-for="(item,index) in list" :key="index">
          <div @click="clickItem(item)">
            <img :src="item.img" alt />
            <span class="projprice">
              {{
              (item.average_price&&"楼盘均价"+item.average_price+"万")||"暂无楼盘均价"
              }}
            </span>
            <span class="projname">{{item.projname}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BScroll from "better-scroll";

export default {
  components: {},
  props: {
    list: Array
  },
  data() {
    return {
      scroll: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    clickItem(item) {
      this.$emit("clickItem", item);
    },
    personScroll() {
      if (this.list) {
        // 默认有六个li子元素，宽度加 margin 左右的值
        let width = this.list.length * 140;
        this.$refs.refListTab.style.width = width + "px";
        // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.refListWarp, {
              startX: 0,
              click: true,
              scrollX: true,
              // 忽略竖直方向的滚动
              scrollY: false,
              eventPassthrough: "vertical"
            });
          } else {
            this.scroll.refresh();
          }
        });
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.personScroll();
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.list-warp {
  overflow: hidden;
}
.item {
  width: 120px;
  height: 150px;
  background: #fff;
  margin: 15px 10px;
  display: inline-block;
  border-radius: 5px;
  padding: 0;
  border-bottom: none;
}
.item > div {
  position: relative;
}

.item img {
  width: 120px;
  height: 120px;
  border-radius: 5px;
  box-shadow: 0 0 5px #cbcbcb;
}
.item .projprice {
  width: 120px;
  line-height: 25px;
  height: 25px;
  font-size: 12px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: -25px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  text-align: right;
  padding-right: 5px;
  box-sizing: border-box;
}
.item .projname {
  width: 120px;
  line-height: 30px;
  height: 30px;
  font-size: 12px;
  display: block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>